import { useEffect, useRef } from 'react'

// To pause or cancel the interval pass `null` in the delay param.
// More info here: https://overreacted.io/making-setinterval-declarative-with-react-hooks/

export const useInterval = (callback, delay) => {
    const savedCallback = useRef();
  
    // Remember the latest function.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);
  
    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
}